(() => {
  function boot(root = document) {
    root.querySelectorAll('[data-ev-bike-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const select = form.querySelector('[data-ev-bike-select]');
      const update = () => { if (select.value.startsWith('/collections/')) form.action = select.value; };
      select.addEventListener('change', update);
      form.addEventListener('submit', event => { if (!select.value) { event.preventDefault(); select.reportValidity(); } else update(); });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
(() => {
  const initOffer = () => {
  const dialog = document.querySelector('[data-ev-offer]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const launcher = document.querySelector('[data-ev-offer-open]');
  const storageKey = 'evbuilt-offer-dismissed-v1';
  let dismissedAt = 0;
  try { dismissedAt = Number(localStorage.getItem(storageKey)) || 0; } catch (_) {}
  let timer;
  const remember = () => {
    clearTimeout(timer);
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
  };
  const open = () => {
    clearTimeout(timer);
    if (Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(modal => modal.getClientRects().length && getComputedStyle(modal).visibility !== 'hidden' && getComputedStyle(modal).opacity !== '0')) return;
    dialog.showModal();
    remember();
  };
  launcher.addEventListener('click', open);
  dialog.querySelector('[data-ev-offer-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', remember);
  dialog.addEventListener('cancel', remember);
  dialog.addEventListener('click', event => { if (event.target === dialog) {
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  }});
  if (Date.now() - dismissedAt > 7 * 24 * 60 * 60 * 1000) {
    timer = setTimeout(() => { if (!document.hidden) open(); }, Number(dialog.dataset.delay) * 1000);
  }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOffer); else initOffer();
})();
